import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { AUTH_CONFIG, AuthConfig } from './lib/auth.config';
import { AuthInterceptor } from './lib/auth.interceptor';
import { provideAuthProvider } from './lib/providers/auth-provider.providers';
import { AuthGuard } from './lib/services/auth.guard';
import { AuthService } from './lib/services/auth.service';
import { provideAuthState } from './lib/state/reducers';

/**
 * Registers the auth feature: NgRx auth state, the selected `AuthProvider` (configured once at startup),
 * `AuthService`, `AuthInterceptor`, `AUTH_CONFIG` and `AuthGuard`.
 */
export function provideAuthModule(config?: Partial<AuthConfig>): EnvironmentProviders[] {
  return [
    ...provideAuthState(),
    provideAuthProvider(config?.provider),
    makeEnvironmentProviders([
      AuthService,
      { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
      { provide: AUTH_CONFIG, useValue: config },
      AuthGuard
    ])
  ];
}
